<script setup>
import { defineProps, ref, computed } from 'vue';
import { isPhonePortrait } from '@/hooks/common/useUtils';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
  featureIcon: {
    type: Array,
    default: () => [],
  },
});

const showMore = ref(true);
const isPhone = ref(isPhonePortrait());

const viewText = computed(() => {
  return showMore.value ? props.config?.viewMoreText : props.config?.viewLessText;
});

const slicedFeatureIcon = computed(() => props.featureIcon.slice(0, 2));

const list = computed(() => {
  if (!isPhone.value) {
    return props.featureIcon;
  }
  return showMore.value ? slicedFeatureIcon.value : props.featureIcon;
});

const toggleMoreText = () => {
  showMore.value = !showMore.value;
};
</script>

<template>
    <div class="tsb-feature-icon" v-if="list.length > 0">
        <div class="tsb-feature-icon-item" v-for="(item, index) in list" :key='"icon"+index'>
            <img class="tsb-feature-icon-item_image" :src="item.image" :alt="item.altText" />
            <div class="tsb-feature-icon-item_describtion">{{ item.description }}</div>
        </div>
       
        <div class="tsb-feature-icon-more" v-if="isPhone && featureIcon.length > 2" @click="toggleMoreText">
            {{ viewText }}
            <i :class='["tsb-feature-icon-more-arrow", showMore && "tsb-feature-icon-more-arrow-down"]'></i>
        </div>
    </div>
</template>